import { Injectable, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Services/common.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { AuthentService } from 'src/app/Services/authent.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DownloadService implements OnInit {

  constructor(
    private commonService: CommonService,
    private errorHandlingService: ErrorHandlingService,
    private shareDataService: SharingDataService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private http: HttpClient,
    private router: Router,
    private authentService: AuthentService,
  ) {
    this.shareDataService.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
  }

  resourceDefinition: any;

  ngOnInit() {


  }

  getGipServicesUrl() {
    return this.commonService.getGipServicesUrl();
  }

  async getData(urls: string[], CallbackFunction) {
    this.authentService.getToken().then(async token => {
      const responses = await Promise.all(urls.map(url => fetch(this.getGipServicesUrl() + url, {
        headers: {
          "Authorization" : `Bearer ${token}`
        }
      })));

      const results = new Array();

      for (const res of responses) {
        if(res.status === 401 && localStorage.getItem("access_token") != null){
          var getRefreshToken = await this.authentService.getRefreshToken();
          this.getData(urls, CallbackFunction);
        }
        const data = await res.json();
        results.push(data.value);
      }

      CallbackFunction(results);
    })
  }

  async getNonOData(urls: string[], CallbackFunction) {
    this.authentService.getToken().then(async token => {
      const responses = await Promise.all(urls.map(url => fetch(this.getGipServicesUrl() + url, {
        headers: {
          "Authorization" : `Bearer ${token}`
        }
      })));

      const results = new Array();

      for (const res of responses) {
        if(res.status === 401 && localStorage.getItem("access_token") != null){
          var getRefreshToken = await this.authentService.getRefreshToken();
          this.getData(urls, CallbackFunction);
        }
        if(res.status === 400 || res.status === 409){
          this.errorHandlingService.showError(this.translateResourceDefinition.transform('ErrUserPassLink', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), 'Error');
          this.router.navigate(["home"]);
          return;
        }
        const data = await res.json();
        results.push(data);
      }

      CallbackFunction(results);
    })
  }



  async postData(url: string, data: any, CallbackFunction: (any) => any, errorCallback?: (response: Response) => any) {
    this.authentService.getToken().then(async token => {
      fetch(this.getGipServicesUrl() + url, {
        method: 'POST', body: JSON.stringify(data), headers: {
          "Content-type": "application/json; charset=UTF-8",
          "Authorization" : `Bearer ${token}`
        }
      })
        .then(async response => {
          if(response.status === 401 && localStorage.getItem("access_token") != null){
            var getRefreshToken = await this.authentService.getRefreshToken();
            this.postData(url, data, CallbackFunction);
          }
          if (response.status < 200 || response.status > 206) {
            if (errorCallback != undefined)
              errorCallback(response);
            else {
              console.error(response);
              this.errorHandlingService.showError(this.getDefaultErrorMessage(), undefined);
            }
            return;
          }
          this.errorHandlingService.showSuccess(undefined, undefined);
          response.json().then(CallbackFunction);
        })
        .catch(err => {
          console.error(err);
        });
    })
  }

  async deleteData(url: string, keys: Map<string, string>, CallbackFunction: (any) => any, errorCallback?: (response: Response) => any) {
    var keysUrl = "";

    if (keys.size === 1)
      keysUrl += keys.values().next().value;
    else {
      for (let [key, value] of keys) {
        if (keysUrl.length > 1) {
          keysUrl += `,`;
        }
        keysUrl += `${key}=${value}`;
      }
    }

    this.authentService.getToken().then(async token => {
      fetch(`${this.getGipServicesUrl()}${url}(${keysUrl})`, {
        method: 'DELETE', 
        headers: {
        "Authorization" : `Bearer ${token}`
      }})
        .then(async response => {
          if(response.status === 401 && localStorage.getItem("access_token") != null){
            var getRefreshToken = await this.authentService.getRefreshToken();
            this.deleteData(url, keys, CallbackFunction, errorCallback);
          }
          if (response.status < 200 || response.status > 206) {
            if (errorCallback != undefined)
              errorCallback(response);

            console.error(response);
            return;
          }
          this.errorHandlingService.showSuccess(null, undefined);
          CallbackFunction(response);
        })
        .catch(err => {
          console.error(err);
        });
    })
  }

  downloadFileDSNB(url: string, CallbackFunction?: (any) => any, errorCallback?: (response: Response)=> any){
    this.authentService.getToken().then(async token => {
      fetch(url, {
        method: 'GET',
        headers: {
          "Authorization" : `Bearer ${token}`
        }
      })
        .then(async response => {
          if(response.status === 401 && localStorage.getItem("access_token") != null){
            var getRefreshToken = await this.authentService.getRefreshToken();
            this.downloadFile(url, CallbackFunction, errorCallback);
          }
          if (response.status < 200 || response.status > 206) {
            if (errorCallback != undefined)
              errorCallback(response);
            else {
              console.error(response);
              this.errorHandlingService.showError(this.getDefaultErrorMessage(), undefined);
            }
            return;
          }
          this.errorHandlingService.showSuccess(undefined, undefined);
          response.arrayBuffer().then(CallbackFunction);
          window.location.href = response.url;
        })
        .catch(err => {
          console.error(err);
        });
    })
  }

  downloadFile(url: string, CallbackFunction?: (any) => any, errorCallback?:(response: Response) => any){
    this.authentService.getToken().then(async token => {
      fetch(url, {
        method: 'GET',
        headers: {
          "Authorization" : `Bearer ${token}`
        }
      }).then(async response => {
        if(response.status === 401 && localStorage.getItem("access_token") != null){
          var getRefreshToken = await this.authentService.getRefreshToken();
          this.downloadFile(url, CallbackFunction, errorCallback);
        }
        if (response.status < 200 || response.status > 206) {
          if (errorCallback != undefined){
            errorCallback(response);
          }
          else {
            console.error(response);
            this.errorHandlingService.showError(this.getDefaultErrorMessage(), undefined);
          }                        
          return;
        }
        this.errorHandlingService.showSuccess(undefined, undefined);
        var hash = await response.json();
        let file: File = null
        fetch(this.commonService.getGipServicesUrl() + `file/ReqDocFile` + `/${hash.hashcode}`).then(async response => {
          let res = await response.blob();
          CallbackFunction(res)
        })
      });
    });
  }

  async uploadFile(url: string, data: any, CallbackFunction?: (any) => any, errorCallback?: (any) => any) {
    const formData: FormData = new FormData();
    formData.append('fileKey', data, data.name);

    this.authentService.getToken().then(async token => {
      fetch(this.commonService.getGipServicesUrl() + url, { method: 'POST', body: formData, headers: {
        "Authorization" : `Bearer ${token}`
      }})
        .then(async response => {
          if(response.status === 401 && localStorage.getItem("access_token") != null){
            var getRefreshToken = await this.authentService.getRefreshToken();
            this.uploadFile(url, data, CallbackFunction, errorCallback);
          }
          if (response.status < 200 || response.status > 299) {
            if (errorCallback != undefined)
              errorCallback(response);
            else {
              this.errorHandlingService.showError(this.getDefaultErrorMessage(), undefined);
            }
          }
          else {
            this.errorHandlingService.showSuccess(undefined, undefined);
          }

          response.json().then(CallbackFunction);
        })
        .catch(err => {
          console.error(err);
        });
    })
  }


  getDefaultErrorMessage() {
    return this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common");
  }
}
